// Recovered compiled webpack factory 87037. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      compileNonPath: function () {
        return c;
      },
      matchHas: function () {
        return u;
      },
      parseDestination: function () {
        return f;
      },
      prepareDestination: function () {
        return d;
      },
    }));
  let n = r(13314),
    a = r(62032),
    o = r(57630),
    i = r(59059),
    s = r(34738);
  function l(e) {
    return e.replace(/__ESC_COLON_/gi, ":");
  }
  function u(e, t, r, n) {
    (void 0 === r && (r = []), void 0 === n && (n = []));
    let a = {},
      o = (r) => {
        let n,
          o = r.key;
        switch (r.type) {
          case "header":
            ((o = o.toLowerCase()), (n = e.headers[o]));
            break;
          case "cookie":
            n = "cookies" in e ? e.cookies[r.key] : (0, i.getCookieParser)(e.headers)()[r.key];
            break;
          case "query":
            n = t[o];
            break;
          case "host": {
            let { host: t } = (null == e ? void 0 : e.headers) || {};
            n = null == t ? void 0 : t.split(":", 1)[0].toLowerCase();
          }
        }
        if (!r.value && n)
          return (
            (a[
              (function (e) {
                let t = "";
                for (let r = 0; r < e.length; r++) {
                  let n = e.charCodeAt(r);
                  ((n > 64 && n < 91) || (n > 96 && n < 123)) && (t += e[r]);
                }
                return t;
              })(o)
            ] = n),
            !0
          );
        if (n) {
          let e = RegExp("^" + r.value + "$"),
            t = Array.isArray(n) ? n.slice(-1)[0].match(e) : n.match(e);
          if (t)
            return (
              Array.isArray(t) &&
                (t.groups
                  ? Object.keys(t.groups).forEach((e) => {
                      a[e] = t.groups[e];
                    })
                  : "host" === r.type && t[0] && (a.host = t[0])),
              !0
            );
        }
        return !1;
      };
    return !(!r.every((e) => o(e)) || n.some((e) => o(e))) && a;
  }
  function c(e, t) {
    if (!e.includes(":")) return e;
    for (let r of Object.keys(t))
      e.includes(":" + r) &&
        (e = e
          .replace(RegExp(":" + r + "\\*", "g"), ":" + r + "--ESCAPED_PARAM_ASTERISKS")
          .replace(RegExp(":" + r + "\\?", "g"), ":" + r + "--ESCAPED_PARAM_QUESTION")
          .replace(RegExp(":" + r + "\\+", "g"), ":" + r + "--ESCAPED_PARAM_PLUS")
          .replace(RegExp(":" + r + "(?!\\w)", "g"), "--ESCAPED_PARAM_COLON" + r));
    return (
      (e = e
        .replace(/(:|\*|\?|\+|\(|\)|\{|\})/g, "\\$1")
        .replace(/--ESCAPED_PARAM_PLUS/g, "+")
        .replace(/--ESCAPED_PARAM_COLON/g, ":")
        .replace(/--ESCAPED_PARAM_QUESTION/g, "?")
        .replace(/--ESCAPED_PARAM_ASTERISKS/g, "*")),
      (0, s.safeCompile)("/" + e, { validate: !1 })(t).slice(1)
    );
  }
  function f(e) {
    let t = e.destination;
    for (let r of Object.keys({ ...e.params, ...e.query }))
      r && (t = t.replace(RegExp(":" + (0, n.escapeStringRegexp)(r), "g"), "__ESC_COLON_" + r));
    let r = (0, a.parseUrl)(t),
      o = r.pathname;
    o && (o = l(o));
    let i = r.href;
    i && (i = l(i));
    let s = r.hostname;
    s && (s = l(s));
    let u = r.hash;
    u && (u = l(u));
    let c = r.search;
    return (c && (c = l(c)), { ...r, pathname: o, hostname: s, href: i, hash: u, search: c });
  }
  function d(e) {
    let t,
      r,
      n = f(e),
      { hostname: a, query: i, search: u } = n,
      d = n.pathname;
    n.hash && (d = "" + d + n.hash);
    let p = [],
      h = [];
    for (let e of ((0, s.safePathToRegexp)(d, h), h)) p.push(e.name);
    if (a) {
      let e = [];
      for (let t of ((0, s.safePathToRegexp)(a, e), e)) p.push(t.name);
    }
    let _ = (0, s.safeCompile)(d, { validate: !1 });
    for (let [r, n] of (a && (t = (0, s.safeCompile)(a, { validate: !1 })), Object.entries(i)))
      Array.isArray(n)
        ? (i[r] = n.map((t) => c(l(t), e.params)))
        : "string" == typeof n && (i[r] = c(l(n), e.params));
    let m = Object.keys(e.params).filter((e) => "nextInternalLocale" !== e);
    if (e.appendParamsToQuery && !m.some((e) => p.includes(e)))
      for (let t of m) t in i || (i[t] = e.params[t]);
    if ((0, o.isInterceptionRouteAppPath)(d))
      for (let t of d.split("/")) {
        let r = o.INTERCEPTION_ROUTE_MARKERS.find((e) => t.startsWith(e));
        if (r) {
          "(..)(..)" === r
            ? ((e.params["0"] = "(..)"), (e.params["1"] = "(..)"))
            : (e.params["0"] = r);
          break;
        }
      }
    try {
      let [a, o] = (r = _(e.params)).split("#", 2);
      (t && (n.hostname = t(e.params)),
        (n.pathname = a),
        (n.hash = (o ? "#" : "") + (o || "")),
        (n.search = u ? c(u, e.params) : ""));
    } catch (e) {
      if (e.message.match(/Expected .*? to not repeat, but got an array/))
        throw Object.defineProperty(
          Error(
            "To use a multi-match in the destination you must add `*` at the end of the param name to signify it should repeat. https://nextjs.org/docs/messages/invalid-multi-match",
          ),
          "__NEXT_ERROR_CODE",
          { value: "E329", enumerable: !1, configurable: !0 },
        );
      throw e;
    }
    return (
      (n.query = { ...e.query, ...n.query }),
      { newUrl: r, destQuery: i, parsedDestination: n }
    );
  }
}
